(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["charity-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function flash(btn, text) {
      btn.textContent = text;
    }

    function handleClick(e) {
      var btn = e.target.closest('.cp__add');
      if (!btn || btn.disabled) return;
      var id = btn.getAttribute('data-variant-id');
      if (!id || btn.classList.contains('is-loading')) return;
      e.preventDefault();

      var original = btn.textContent;
      btn.classList.add('is-loading');
      flash(btn, 'Adding…');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          return res.json();
        })
        .then(function () {
          flash(btn, 'Added ✓');
          try {
            if (window.jQuery && typeof window.adjustCartDropDown === 'function') {
              window.adjustCartDropDown();
            }
          } catch (err) {}
          setTimeout(function () {
            btn.classList.remove('is-loading');
            flash(btn, original);
          }, 1800);
        })
        .catch(function () {
          flash(btn, 'Try again');
          setTimeout(function () {
            btn.classList.remove('is-loading');
            flash(btn, original);
          }, 1800);
        });
    }

    document.addEventListener('click', handleClick);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["event-detail"]) return;
  try {
    
  (function () {
    function flash(btn, text) {
      btn.textContent = text;
    }

    function handleClick(e) {
      var btn = e.target.closest('.event-detail__buy-btn');
      if (!btn || btn.disabled) return;
      var id = btn.getAttribute('data-variant-id');
      if (!id || btn.classList.contains('is-loading')) return;
      e.preventDefault();

      var qty = 1;
      var qtyInput = document.getElementById(btn.getAttribute('data-qty-input') || '');
      if (qtyInput) {
        qty = parseInt(qtyInput.value, 10);
        if (isNaN(qty) || qty < 1) qty = 1;
      }

      var original = btn.textContent;
      btn.classList.add('is-loading');
      flash(btn, 'Adding…');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: qty })
      })
        .then(function (res) {
          if (res.status === 422) throw new Error('stock');
          if (!res.ok) throw new Error('add failed');
          return res.json();
        })
        .then(function () {
          flash(btn, 'Added ✓');
          try {
            if (window.jQuery && typeof window.adjustCartDropDown === 'function') {
              window.adjustCartDropDown();
            }
          } catch (err) {}
          setTimeout(function () {
            btn.classList.remove('is-loading');
            flash(btn, original);
          }, 1800);
        })
        .catch(function (err) {
          flash(btn, err && err.message === 'stock' ? 'Not enough left' : 'Try again');
          setTimeout(function () {
            btn.classList.remove('is-loading');
            flash(btn, original);
          }, 1800);
        });
    }

    document.addEventListener('click', handleClick);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function flash(btn, text) {
      btn.textContent = text;
    }

    function handleClick(e) {
      var btn = e.target.closest('.cp__add');
      if (!btn || btn.disabled) return;
      var id = btn.getAttribute('data-variant-id');
      if (!id || btn.classList.contains('is-loading')) return;
      e.preventDefault();

      var original = btn.textContent;
      btn.classList.add('is-loading');
      flash(btn, 'Adding…');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          return res.json();
        })
        .then(function () {
          flash(btn, 'Added ✓');
          try {
            if (window.jQuery && typeof window.adjustCartDropDown === 'function') {
              window.adjustCartDropDown();
            }
          } catch (err) {}
          setTimeout(function () {
            btn.classList.remove('is-loading');
            flash(btn, original);
          }, 1800);
        })
        .catch(function () {
          flash(btn, 'Try again');
          setTimeout(function () {
            btn.classList.remove('is-loading');
            flash(btn, original);
          }, 1800);
        });
    }

    document.addEventListener('click', handleClick);
  })();

  } catch(e) { console.error(e); }
})();
})();
